import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFolderOpen = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.816 18.475a2.41 2.41 0 0 1-2.408 2.409l13.123.003a2.41 2.41 0 0 0 2.407-2.408L21 13.686c0-2.148-1.329-3.16-2.912-3.16h-7.359c-1.583 0-2.912 1.012-2.912 3.16z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.631 10.752V9.704c-.05-2.537-1.614-3.772-4.48-3.772h-1.532a2.12 2.12 0 0 1-1.692-.847l-.846-1.125a2.12 2.12 0 0 0-1.691-.847H7.536C4.218 3.113 3 5.07 3 8.381v10.094a2.41 2.41 0 0 0 2.408 2.409"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFolderOpen);
export default ForwardRef;
